import { NumberInput } from './Number';

export type { InputProps } from '../types';
export default NumberInput;
